// Export lazy (las libs pesadas solo se cargan al usar), como el dashboard del POS.

export type ExportRow = Record<string, string | number>;

export async function exportExcel(filename: string, rows: ExportRow[]): Promise<void> {
  const XLSX = await import('xlsx');
  const ws = XLSX.utils.json_to_sheet(rows);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Datos');
  XLSX.writeFile(wb, `${filename}.xlsx`);
}

export async function exportPdf(
  filename: string,
  title: string,
  headers: string[],
  rows: (string | number)[][],
): Promise<void> {
  const { jsPDF } = await import('jspdf');
  const autoTable = (await import('jspdf-autotable')).default;
  const doc = new jsPDF();
  doc.setFontSize(14);
  doc.text(title, 14, 16);
  autoTable(doc, {
    head: [headers],
    body: rows.map((r) => r.map(String)),
    startY: 22,
    headStyles: { fillColor: [185, 28, 28] },
  });
  doc.save(`${filename}.pdf`);
}

export async function exportImage(el: HTMLElement, filename: string): Promise<void> {
  const { toPng } = await import('html-to-image');
  const url = await toPng(el, { backgroundColor: '#ffffff', pixelRatio: 2 });
  const a = document.createElement('a');
  a.href = url;
  a.download = `${filename}.png`;
  a.click();
}
